export default "__VITE_ASSET__BmUmWSTD__"